'use strict';

import './vm-action-column';
import './index.scss';

import app from '../ngmodule';
import angular from 'angular';
import { ControllerBase } from '../control-base';

export class ActionsPanelController extends ControllerBase {
    public prompt: string | undefined;
    public cssClass: string | undefined;

    static $inject = ['$element', '$timeout'];
    constructor(protected $element: ng.IRootElementService, protected $timeout: ng.ITimeoutService) {
        super();
    }

    protected valuesFromHtml() : void {
        if (this.prompt == undefined) {
            this.prompt = this.valueFromHtml("prompt", '', this.$element);
        }

        if (this.cssClass == undefined) {
            this.cssClass = this.valueFromHtml("class", '', this.$element);
        }
    }

    $onInit(): void {
        this.valuesFromHtml();
    }

    $onChanges(changes: angular.IOnChangesObject): void {
        if(changes.prompt && changes.prompt.currentValue != undefined) {
            this.prompt = changes.prompt.currentValue;
        }
    }
}

app.component('vmActionsPanel', {
    template: require('./template.html').default,
    bindings: {
        prompt: '<'
    },
    transclude: {
        'header': '?vmActionsPanelPrompt',
        'body': 'vmActionsPanelBody'
    },
    controller:  ActionsPanelController
});